module.exports = __webpack_public_path__ + "assets/img/gift-box.35841ade.webp";